<template>
  <div class="info-page">
    <div class="language-selector">
      <div v-for="(lang, i) in languages" :key="lang[i]" class="language"
      v-on:click="changeLanguage(lang)">
        {{ lang }}
      </div>
    </div>
    <div class="page-header">INFO</div>
    <english-info v-if="currentLanguage == 'EN'" />
    <myanmar-info v-if="currentLanguage == 'MYA'" />
    <german-info v-if="currentLanguage == 'DE'" />
  </div>
</template>

<script>
import EnglishInfo from "./EnglishInfo.vue";
import MyanmarInfo from "./MyanmarInfo.vue";
import GermanInfo from "./GermanInfo.vue";
export default {
  name: "InfoPage",
  components: {
    EnglishInfo,
    MyanmarInfo,
    GermanInfo
  },
  data: () => ({
    currentLanguage: "EN",
    languages: ["EN", "DE", "MYA"],
  }),
  methods: {
    changeLanguage: function(lang){
      this.currentLanguage = lang;
    }
  },
};
</script>

<style>
.info-page {
  position: relative;
  top: 12vh;
  padding: 3vh 5vw;
  z-index: 0;
}
p {
  font-family: "Lato";
  margin: 2vh 0;
  color: white;
}

.language-selector {
  font-size: 1.5em;
  color:#ffe500;
  display: flex;
}
.language {
  font-family: "Oswald";
  padding-right: 2vh;
}
</style>